const normalizeText = (value) => {
  if (value == null) return '';
  return String(value).trim();
};

const stripTrailingSlash = (value) => normalizeText(value).replace(/\/+$/, '');

export const getApiBaseUrl = () => stripTrailingSlash(import.meta.env.VITE_API_BASE_URL || '');

export const buildApiUrl = (path = '') => {
  const normalizedPath = normalizeText(path);
  if (!normalizedPath) {
    return getApiBaseUrl();
  }

  if (/^https?:\/\//i.test(normalizedPath)) {
    return normalizedPath;
  }

  const baseUrl = getApiBaseUrl();
  const resolvedPath = normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`;
  return baseUrl ? `${baseUrl}${resolvedPath}` : resolvedPath;
};

